@if (!appSettings.isMobile()) {
<div>
    <!-- Header & Filters -->
    <div class="row mb-2 align-items-end">
        <div class="col-md-12">
            <ng-select [items]="users" [selectableGroup]="true" [hideSelected]="false" bindLabel="displayName"
                [multiple]="true" [closeOnSelect]="false" [hideSelected]="true" [dropdownPosition]="'bottom'"
                bindValue="uuid" placeholder="Filtrar Usuarios" (change)="changeSelect()" [(ngModel)]="usersSelected">
            </ng-select>
        </div>
        <div class="col-md-12 mt-2 d-flex gap-2 mb-2">
            <span class="filter-badge" [class.active]="badgeValue() === 'true' && fieldBadge() === 'isActive'"
                (click)="toggleBadge('isActive','true')">
                <i class="fas fa-check-circle me-1" *ngIf="badgeValue() === 'true' && fieldBadge() === 'isActive'"></i>
                Activos
            </span>
            <span class="filter-badge" [class.active]="badgeValue() === 'false' && fieldBadge() === 'isActive'"
                (click)="toggleBadge('isActive','false')">
                <i class="fas fa-times-circle me-1" *ngIf="badgeValue() === 'false' && fieldBadge() === 'isActive'"></i>
                Inactivos
            </span>
        </div>
    </div>

    <!-- Table -->
    <div>
        <div class="table-responsive table-data">
            <table class="table table-hover table-sm">

                <tbody>
                    <!-- Carga -->
                    @if(isLoading){
                    @for( i of rows ;track $index){
                    <tr class="tr-custom">
                        <td>
                            <p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p>
                        </td>
                    </tr>
                    }
                    }

                    @if(filteredUsers?.length>0 && !isLoading){
                    @for(user of filteredUsers; track user.uuid) {
                    <tr (click)="selectUser(user)" [class.active-row]="selectedId() === user.uuid"
                        style="cursor: pointer;">
                        <td class="text-nowrap px-3">
                            <span class="fw-bold d-block">{{ user.displayName }}</span>
                            <small class="text-muted">{{ user.isActive ? 'Activo' : 'Inactivo' }}</small>
                            @if (roleSummary(user); as summary) {
                            <small class="d-block text-info">{{ summary }}</small>
                            }
                        </td>
                    </tr>
                    }
                    }

                </tbody>
            </table>

            @if(filteredUsers?.length==0 && !isLoading){
            <div class="m-l-10 mb-2">
                <em>No hay datos</em>
            </div>
            }
        </div>
    </div>
</div>
} @else {
<app-mobile-footer>
    <input type="search"
           class="form-control mobile-footer-search"
           placeholder="Buscar usuario..."
           [(ngModel)]="searchText"
           (ngModelChange)="changeSelect()">
    <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
            [class.btn-outline-primary]="!!badgeValue()"
            (click)="mobileFiltersOpen = true">
        <i class="fas fa-filter me-1"></i>Filtros
        @if (badgeValue()) {
            <span class="badge bg-primary ms-1">1</span>
        }
    </button>
</app-mobile-footer>
<app-bottom-sheet [open]="mobileFiltersOpen" title="Filtros" (closed)="mobileFiltersOpen = false">
    <div class="d-flex flex-wrap gap-2 px-3 pb-3">
        <span class="filter-badge"
              role="button"
              tabindex="0"
              [class.active]="badgeValue() === 'true' && fieldBadge() === 'isActive'"
              (click)="toggleBadge('isActive','true')">
            Activos
        </span>
        <span class="filter-badge"
              role="button"
              tabindex="0"
              [class.active]="badgeValue() === 'false' && fieldBadge() === 'isActive'"
              (click)="toggleBadge('isActive','false')">
            Inactivos
        </span>
    </div>
</app-bottom-sheet>

<div class="d-flex justify-content-between align-items-center mb-2 px-1">
    <span class="small text-muted fw-bold text-uppercase">
        REGISTROS @if (!isLoading) { ({{ filteredUsers.length }}) }
    </span>
</div>

<div class="mobile-cards-scroll">
    @if (isLoading) {
        @for (i of rows; track $index) {
            <app-list-card [isLoading]="true"></app-list-card>
        }
    } @else {
        @for (user of filteredUsers; track user.uuid) {
            <app-list-card
                [isShortcut]="true"
                (click)="selectUser(user)">
                <div cardTitle class="fw-bold text-dark text-truncate">
                    {{ user.displayName }}
                </div>
                <div cardBadge>
                    <span class="badge"
                          [class.text-bg-success]="user.isActive"
                          [class.text-bg-secondary]="!user.isActive">
                        {{ user.isActive ? 'Activo' : 'Inactivo' }}
                    </span>
                </div>
                <div class="text-muted small text-truncate">{{ user.mail }}</div>
                <div cardExtra>
                    @if (roleSummary(user); as summary) {
                        {{ summary }}
                    }
                </div>
            </app-list-card>
        }
    }

    @if (!isLoading && filteredUsers.length === 0) {
        <div class="card border-0 shadow-sm p-4 text-center my-2">
            <i class="fas fa-users fa-3x text-muted opacity-50 mb-2"></i>
            <h6 class="text-muted mb-1">Sin usuarios</h6>
            <small class="text-muted">Ajusta los filtros o crea uno nuevo.</small>
        </div>
    }
</div>
}
